import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { sr } from "../../lib/sr";

// Path-based white-label entry: /a/:slug (agency portal) or /w/:slug (client workspace).
// Resolves the slug to its branding, themes the session, then sends the visitor to login.
export default function WhiteLabelEntry() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState(false);

  useEffect(() => {
    let alive = true;
    sr.resolveSlug(slug)
      .then((r) => {
        if (!alive) return;
        if (r?.found && r.branding) {
          sessionStorage.setItem("wl_brand", JSON.stringify(r.branding));
          sessionStorage.setItem("wl_slug", slug);
        } else {
          sessionStorage.removeItem("wl_brand");
          sessionStorage.removeItem("wl_slug");
        }
        const authed = !!localStorage.getItem("tr_token");
        nav(authed ? "/app" : "/login", { replace: true });
      })
      .catch(() => {
        if (!alive) return;
        setErr(true);
        setTimeout(() => nav("/login", { replace: true }), 1200);
      });
    return () => { alive = false; };
  }, [slug]); // eslint-disable-line

  return (
    <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", color: "#64748b" }} data-testid="wl-entry">
      <div style={{ textAlign: "center" }}>
        <Loader2 className="sr-spin" size={26} />
        <div style={{ marginTop: 10, fontSize: 13 }}>{err ? "Link not found — taking you to sign in…" : "Loading your branded portal…"}</div>
      </div>
    </div>
  );
}
